import {
    BUSCAR_TODOS_DESTINATARIOS,
    BUSCAR_TODOS_DESTINATARIOS_SUCESSO,
    BUSCAR_DESTINATARIOS_CIDADE,
    BUSCAR_DESTINATARIOS_CIDADE_SUCESSO,
    DESTINATARIOS_MENSAGEM,
    SET_ESTADO_SELECIONADO,
    SET_CIDADE_SELECIONADA,
    MOSTRAR_LOAD_LISTA_DESTINATARIOS,
    MARCAR_DESTINATARIO_SELECIONADO,
    MARCAR_SELECIONADO_TODOS_DESTINATARIOS,
    DESMARCAR_SELECIONADO_TODOS_DESTINATARIOS,
    HABILITAR_ESTADO,
    ORDER_BY_DEST,
    LINHAS_POR_PAGINA_DEST,
    MUDAR_PAGINA_DEST,
    SET_DEST_INDEX_SELECIONADOS,
    VERIFICAR_DESTINATARIOS_ASSOCIADOS,
    VERIFICAR_DESTINATARIOS_ASSOCIADOS_SUCESSO,
    VERIFICAR_DESTINATARIOS_ASSOCIADOS_DADOS,
    SET_DEST_STATUS,
    SET_DEST_STATUS_SUCESSO,
    DESATIVAR_DEST_SEM_ROTA,
    SELECIONAR_DEST_DIST,
    COLUNAS_TABELA_DEST,
    MUDAR_TIPO_DEST_TABELA,
    SET_DEST_TABELA,
    ABRIR_DEST_SELECIONADO,
    BUSCAR_DEST_POR_ESTADO,
    BUSCAR_DEST_POR_ESTADO_SUCESSO,
    MUDAR_NIVEL_TABELA_DEST,
    SET_LOADER_LISTA_DESTINATARIOS,
    LIMPAR_TABELA_DEST,
    SET_TIPO_TABELA_DEST
} from "constants/ActionTypes";

export const buscarTodosDestinatarios = cnpjEmpresa => {
    return {
        type: BUSCAR_TODOS_DESTINATARIOS,
        payload: cnpjEmpresa
    };
};

export const buscarTodosDestinatariosSucesso = destinatarios => {
    return {
        type: BUSCAR_TODOS_DESTINATARIOS_SUCESSO,
        payload: destinatarios
    };
};

export const mostrarDestinatariosMensagem = mensagem => {
    return {
        type: DESTINATARIOS_MENSAGEM,
        payload: mensagem
    };
};
export const setEstadoSelecionado = estado => {
    return {
        type: SET_ESTADO_SELECIONADO,
        payload: estado
    };
};
export const setCidadeSelecionada = dados => {
    return {
        type: SET_CIDADE_SELECIONADA,
        payload: dados
    };
};
export const habilitarEstado = () => {
    return {
        type: HABILITAR_ESTADO
    };
};
export const buscarDestinatariosCidade = dados => {
    return {
        type: BUSCAR_DESTINATARIOS_CIDADE,
        payload: dados
    };
};
export const buscarDestinatariosCidadeSucesso = destinatarios => {
    return {
        type: BUSCAR_DESTINATARIOS_CIDADE_SUCESSO,
        payload: destinatarios
    };
};
export const mostrarLoadListaDestinatarios = () => {
    return {
        type: MOSTRAR_LOAD_LISTA_DESTINATARIOS
    };
};
export const marcarDestinatarioSelecionado = destinatario => {
    return {
        type: MARCAR_DESTINATARIO_SELECIONADO,
        payload: destinatario
    };
};
export const marcarTodosDestintariosSelecionado = () => {
    return {
        type: MARCAR_SELECIONADO_TODOS_DESTINATARIOS
    };
};
export const desmarcarTodosDestintariosSelecionado = () => {
    return {
        type: DESMARCAR_SELECIONADO_TODOS_DESTINATARIOS
    };
};
export const orderByDest = data => {
    return {
        type: ORDER_BY_DEST,
        payload: data
    };
};
export const linhasPorPaginaDest = data => {
    return {
        type: LINHAS_POR_PAGINA_DEST,
        payload: data
    };
};
export const mudarPaginaDest = data => {
    return {
        type: MUDAR_PAGINA_DEST,
        payload: data
    };
};
export const setDestIndexSelecionados = data => {
    return {
        type: SET_DEST_INDEX_SELECIONADOS,
        payload: data
    };
};
export const verificarDestinatariosAssociados = data => {
    return {
        type: VERIFICAR_DESTINATARIOS_ASSOCIADOS,
        payload: data
    };
};
export const verificarDestinatariosAssociadosSucesso = data => {
    return {
        type: VERIFICAR_DESTINATARIOS_ASSOCIADOS_SUCESSO,
        payload: data
    };
};
export const verificarDestinatariosAssociadosDados = data => {
    return {
        type: VERIFICAR_DESTINATARIOS_ASSOCIADOS_DADOS,
        payload: data
    };
};
export const setDestStatus = dados => {
    return {
        type: SET_DEST_STATUS,
        payload: dados
    };
};
export const setDestStatusSucesso = dados => {
    return {
        type: SET_DEST_STATUS_SUCESSO,
        payload: dados
    };
};
export const desativarDestSemRota = () => {
    return {
        type: DESATIVAR_DEST_SEM_ROTA
    };
};
export const colunasTabelaDest = dados => {
    return {
        type: COLUNAS_TABELA_DEST,
        payload: dados
    };
};
export const mudarTipoDestTabela = dados => {
    return {
        type: MUDAR_TIPO_DEST_TABELA,
        payload: dados
    };
};
export const setDestTabela = dados => {
    return {
        type: SET_DEST_TABELA,
        payload: dados
    };
};
export const abrirDestSelecionado = dados => {
    return {
        type: ABRIR_DEST_SELECIONADO,
        payload: dados
    };
};
export const buscarDestPorEstado = dados => {
    return {
        type: BUSCAR_DEST_POR_ESTADO,
        payload: dados
    };
};
export const buscarDestPorEstadoSucesso = dados => {
    return {
        type: BUSCAR_DEST_POR_ESTADO_SUCESSO,
        payload: dados
    };
};
export const mudarNivelTabelaDest = dados => {
    return {
        type: MUDAR_NIVEL_TABELA_DEST,
        payload: dados
    };
};
export const setLoaderListaDestinatarios = dados => {
    return {
        type: SET_LOADER_LISTA_DESTINATARIOS,
        payload: dados
    };
};
export const limparTabelaDest = dados => {
    return {
        type: LIMPAR_TABELA_DEST,
        payload: dados
    };
};
export const setTipoTabelaDest = dados => {
    return {
        type: SET_TIPO_TABELA_DEST,
        payload: dados
    };
};
